import React, { HTMLAttributes } from "react";

import { SpanContainer } from "./styles";

type SpanProps = HTMLAttributes<HTMLSpanElement>;

const Span: React.FC<SpanProps> = ({ children, ...rest }) => {
  const handleMouseOver = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    const element = event.currentTarget;

    const parentElement = element?.parentElement;

    if (!parentElement) throw new Error("span must have a parent.");

    const speedOfTransition = 20;

    if (element.scrollWidth > parentElement.clientWidth) {
      element.style.transition = `all ${
        (element.scrollWidth - parentElement.clientWidth) / speedOfTransition
      }s`;
      element.classList.remove("ellipsis");
      element.style.transform = `translateX(${
        parentElement.clientWidth - element.scrollWidth
      }px)`;
    }
  };

  const handleMouseOut = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    const element = event.currentTarget;

    const parentElement = element?.parentElement;

    if (!parentElement) throw new Error("span must have a parent.");

    if (element.scrollWidth > parentElement.clientWidth) {
      element.style.transition = "all 0.3s";
      element.style.transform = "translateX(0px)";
      element.classList.add("ellipsis");
    }
  };

  return (
    <SpanContainer
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      className="ellipsis"
      {...rest}
    >
      {children}
    </SpanContainer>
  );
};

export default Span;
